import React from 'react';
import { Text } from '@groupelacentrale/contact-storybook';
import { StyledContainer } from 'components';

interface Props {
  title: React.ReactNode;
  open: boolean;
  id: string;
  onOpen: (id?: string) => undefined | void;
  onClose: () => undefined | void;
  updatedFields: number;
  errorFields?: number;
  children: React.ReactNode;
}

const Block: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
  { title, children, updatedFields, errorFields = 0, ...props },
  ref?,
) => {
  return (
    <StyledContainer
      {...props}
      ref={ref}
      title={
        <>
          <Text weight="bold" size="large">
            {title}
          </Text>{' '}
          {updatedFields !== 0 && <span className="updated-field-counter">{updatedFields} champ(s) modifié(s)</span>}
          {errorFields !== 0 && (
            <span className="error-field-counter">{errorFields} champ(s) obligatoire(s) non renseigné(s)</span>
          )}
        </>
      }
    >
      {children}
    </StyledContainer>
  );
};

export const UpdateDepositFormBlock = React.forwardRef(Block);
